export default __webpack_public_path__ + "static/media/enter-white.28858ff8.svg";